import { Hero05articles } from './Images.js';
import HeaderMenu from './HeaderMenu.js';
import HeroImage from './components/HeroImage';
import './css/App.css';
import { useDocumentTitle } from "./hooks/useDocumentTitle";
import ArticleCard from './ArticleCard.js';

import { AboutHandsFire } from './Images.js';
import { AboutJumpLake } from './Images.js';
import { AboutWalkDogs } from './Images.js';
import { Hero07contact } from './Images.js';
import { PhotoFire02 } from './Images.js';
import { PhotoNitro2 } from './Images.js';

import { useMediaQuery } from 'react-responsive';

function Articles() {
  useDocumentTitle("Articles");
  const isMobile = useMediaQuery({ query: `(max-width: 960px)` });

  return (
      <div className="sectionbody"> 
        <HeaderMenu />

        <div className={isMobile ? "hero-image-area-mobile" : "hero-image-area"}>
            <HeroImage src={Hero05articles} alt="Articles and Publications featuring Kate the Chemist" />
        </div>

        <div className={isMobile ? "intro-paragraph-area-mobile" : "intro-paragraph-area"}>
            <h1>Articles and Publications</h1>
            Kate the Chemist has been widely recognized by leading national media for her innovative approach to science communication. Her work has been featured in The New York Times, The Wall Street Journal, and The Washington Post, with in-depth articles highlighting her ability to make chemistry accessible, entertaining, and relevant to everyday life. These profiles underscore her growing impact as a trusted public voice for science and a trailblazer in engaging broad audiences with complex ideas.

            <div className={isMobile? "article-cards-mobile" : "article-cards"}>
              <ArticleCard 
                pub="Wall Street Journal"
                title="The Female Scientist Who Wants to Blow Up Your TV" 
                subtitle="A trail blazed by TV personalities like Mr. Wizard and Bill Nye the Science Guy hasn’t featured well-known women. Enter Kate the Chemist"
                url="https://www.wsj.com/articles/the-female-scientist-who-wants-to-blow-up-your-tv-1544020204"
              />

              <ArticleCard 
                pub="New York Times"
                title="The Explosive Ambitions of Kate the Chemist" 
                subtitle="At the lecture halls of the University of Texas or on TV, Kate Biberdorf is working to catalyze more people into careers in science."
                url="https://www.nytimes.com/2022/07/11/science/kate-chemist-tv.html"
              />

              <ArticleCard 
              pub="Wall Street Journal"
                title="3 Super-Fun Experiments for Pint-size Scientists" 
                subtitle="Kate Biberdorf—aka 'Kate the Chemist'—shares three awe-inspiring, safe, occasionally yummy home experiments for curious kids"
                url="https://www.wsj.com/articles/3-super-fun-experiments-for-pint-size-scientists-1534435526"
              />

              <ArticleCard 
                pub="Washington Post"
                title="This teacher aims to get kids fired up about chemistry" 
                subtitle="Kate Biberdorf, a chemistry professor at the University of Texas at Austin, uses fire and explosions to get kids excited about science."
                url="https://www.washingtonpost.com/lifestyle/kidspost/this-teacher-aims-to-get-kids-fired-up-about-chemistry/2018/03/26/c99e7bf6-225f-11e8-badd-7c9f29a55815_story.html"
              />

              <ArticleCard 
                pub="Inside Higher Ed"
                title="How scientists use public engagement to combat misinformation" 
                subtitle="Scientists have the knowledge to combat misinformation online, and now some are receiving the institutional support to communicate with a broad public audience."
                url="https://www.insidehighered.com/news/faculty-issues/teaching/2024/09/06/how-scientists-use-public-engagement-combat-misinformation"
              />

              <ArticleCard 
                pub="C&EN"
                title="What's next for Kate the Chemist?" 
                subtitle="Kate Biberdorf heads to the University of Notre Dame to become the institution's first professor for the public understanding of science"
                url="https://cen.acs.org/people/profiles/s-next-Kate-Chemist/102/i34"
              />

              <ArticleCard 
                pub="Austin Chronicle"
                title="Kate the Chemist Says Anybody Can Be a Scientist" 
                subtitle="Dr. Kate Biberdorf brings chemistry to the masses with explosive experiments and a passion for STEM education"
                url="https://www.austinchronicle.com/features/kate-the-chemist-says-anybody-can-be-a-scientist-12832301/"
              />
            </div>
        </div>

        <div className="blue-bg-area">
          <div className="about-img-container">
            <img className="about-gallery-img" src={ PhotoFire02 } />
            <img className="about-gallery-img" src={ Hero07contact } />
            <img className="about-gallery-img" src={ PhotoNitro2 } />
          </div>
        </div>

      </div>


  );
}

export default Articles;
